// Static fallback for the pricing cards — used when subscriptions are NOT
// enabled for the tenant (or its plan list is empty / the tenant fetch
// failed). When subscriptions ARE enabled, PricingGrid renders the tenant's
// configured `stripe.plans` instead. Keep these names/prices/royalty shares
// in sync with the backend defaults in
// server/utils/subscriptions/defaultPlans.ts.
//
// `name` is the STABLE internal id (checkout + tier resolution match on
// it); customer-facing branding is `displayName`. Feature entries are
// i18n keys (`plan_features.*`) — PricingCard translates known keys and
// renders unknown strings verbatim.
export default () => [
  {
    name: 'Creator-Free',
    displayName: 'Starter',
    priceId: '',
    price: 0,
    keepRoyalties: null,
    royaltySharePct: 15,
    grantsLabelManager: false,
    features: [
      'plan_features.unlimited_releases',
      'plan_features.all_stores',
      'plan_features.analytics',
      'plan_features.monthly_payouts',
      'plan_features.shoplinks',
      'plan_features.marketplace',
      'plan_features.splits',
      'plan_features.ai_studio'
    ]
  },
  {
    name: 'Creator-Paid',
    displayName: 'Pro',
    priceId: '',
    price: 9.99,
    keepRoyalties: null,
    royaltySharePct: 0,
    grantsLabelManager: false,
    features: [
      'plan_features.everything_starter',
      'plan_features.keep_100',
      'plan_features.ads_manager',
      'plan_features.social_posting',
      'plan_features.adv_analytics',
      'plan_features.priority_support'
    ]
  },
  {
    name: 'Label Manager',
    displayName: 'Label',
    priceId: '',
    price: 19.99,
    keepRoyalties: null,
    royaltySharePct: 10,
    grantsLabelManager: true,
    features: [
      'plan_features.everything_pro',
      'plan_features.label_share',
      'plan_features.own_labels',
      'plan_features.royalty_accounting',
      'plan_features.team',
      'plan_features.contracts_ar',
      'plan_features.label_payouts'
    ]
  }
]
